import React from 'react';

interface StatsPanelProps {
  total: number;
  searchTime: number;
  bestScore: number | null;
  avgScore: number | null;
}

export const StatsPanel: React.FC<StatsPanelProps> = ({
  total,
  searchTime,
  bestScore,
  avgScore,
}) => {
  return (
    <div className="bg-gray-50 rounded-lg border border-gray-200 p-4 sm:p-6">
      <h3 className="font-semibold text-gray-900 text-sm mb-3">ESTADÍSTICAS</h3>

      <div className="grid grid-cols-2 lg:grid-cols-1 gap-3 lg:gap-0 lg:divide-y lg:divide-gray-200">
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center lg:py-3">
          <span className="text-xs text-gray-500">Total docs</span>
          <span className="text-sm font-semibold text-[#0943B5]">{total}</span>
        </div>

        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center lg:py-3">
          <span className="text-xs text-gray-500">Tiempo</span>
          <span className="text-sm font-semibold text-[#0943B5]">{searchTime.toFixed(2)}s</span>
        </div>

        {bestScore !== null && (
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center lg:py-3">
            <span className="text-xs text-gray-500">Mejor</span>
            <span className="text-sm font-semibold text-[#0943B5]">
              {((1 - bestScore) * 100).toFixed(0)}%
            </span>
          </div>
        )}

        {avgScore !== null && (
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center lg:py-3">
            <span className="text-xs text-gray-500">Promedio</span>
            <span className="text-sm font-semibold text-[#0943B5]">
              {((1 - avgScore) * 100).toFixed(0)}%
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
